import FormAccordions from "@components/core/accordions/FormAccordions";
import PageLayout from "@components/core/layouts/PageLayout";
import CardSection from "@components/core/section/CardSection";
import { ROUTES } from "@routes/Routes";
import ScellementMessageSection from "@views/core/extranet/transactions/scellement/sections/ScellementMessageSection";
import FilesToSignSection from "@views/core/extranet/transactions/signature/sections/FilesToSignSection";
import OfficeChoiceSection from "@views/core/extranet/transactions/signature/sections/OfficeChoiceSection";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import useTransactionScreen from "@views/core/extranet/transactions/useTransactionScreen";

const ScellementScreen: FunctionComponent = () => {
  const { t } = useTranslation();

  const {
    activeBadge,
    setActiveBadge,
    handleChangeBadge,
    preselectedOfficeId,
    endOfTransaction,
    files,
  } = useTransactionScreen("scellement");

  const currentFileCount = files.length; // No attachments for scellement

  return (
    <PageLayout
      container
      returnRoute={ROUTES.extranet.home.generate()}
      hideDropdown
    >
      <CardSection title={t("scellement.title")}>
        <FormAccordions
          activeTab={activeBadge}
          setActiveTab={setActiveBadge}
          sections={[
            {
              key: "1",
              title: t("signature.accordion.officeChoice"),
              content: (
                <OfficeChoiceSection
                  onSubmit={() => handleChangeBadge(1)}
                  preselectedOfficeId={preselectedOfficeId}
                />
              ),
            },
            {
              key: "2",
              title: t("scellement.accordion.document"),
              content: (
                <FilesToSignSection
                  onSubmit={() => handleChangeBadge(2)}
                  isSignature={false}
                  description={t(
                    "scellement.accordion.documentForm.description",
                  )}
                  descriptionSeparator={t(
                    "scellement.accordion.documentForm.descriptionSeparator",
                  )}
                  descriptionUrlTitle={t(
                    "scellement.accordion.documentForm.descriptionUrlTitle",
                  )}
                  currentFileCount={currentFileCount}
                />
              ),
            },
            {
              key: "3",
              title: t("scellement.accordion.message"),
              content: (
                <ScellementMessageSection
                  officeId={preselectedOfficeId}
                  endOfTransaction={endOfTransaction}
                />
              ),
            },
          ]}
        />
      </CardSection>
    </PageLayout>
  );
};

export default ScellementScreen;
